import Modal from "../components/Modal";
import { ModalInfo } from "../interfaces/ModalInfo";
import { Product } from "../interfaces/Product";

interface ModalInterface<T extends Product> {
  modal: ModalInfo<T>;
  setModal: (isOpen: boolean, selected: T | undefined) => void;
  children: React.ReactNode;
}

export default function ProductModal<T extends Product>(
  props: ModalInterface<T>,
) {
  const { modal, setModal, children } = props;

  return modal.selected ? (
    <Modal
      isOpen={modal.isOpen}
      onClose={() => setModal(false, modal.selected)}
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        {modal.selected.name}
      </h2>

      <div className="mb-2">
        <label className="text-xl text-gray-600">위치: </label>
        <label className="text-xl text-gray-700 font-semibold">
          {modal.selected.location}
        </label>
      </div>
      {modal.selected.note ? (
        <div className="mb-2">
          <label className="text-xl text-gray-600">비고: </label>
          <label className="text-xl text-red-500 font-semibold">
            {modal.selected.note}
          </label>
        </div>
      ) : (
        <></>
      )}
      {children}
    </Modal>
  ) : (
    <></>
  );
}
